import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    all: [],
    note: {
      name: '',
      message: '',
    },
  },
  mutations: {
    updateNote(state, note) {
      state.note = note;
    },
    updateNotes(state, notes) {
      state.all = notes;
    },
    addNote(state, note) {
      state.all.push(note);
    },
    putNote(state, note) {
      state.all = state.all.map((value) => (note.id === value.id ? note : value));
    },
    deleteAction(state, id) {
      state.all = state.all.filter((note) => note.id !== id);
    },
  },
  actions: {

    getNote({ commit }, { clientId, noteId }) {
      axiosInstance.get(urlsAPI.clientsURL + clientId + urlsAPI.notesURL + noteId)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateNote', response.data);
          }
        })
        .catch(handlerError);
    },

    getNotes({ commit }, clientId) {
      axiosInstance.get(urlsAPI.clientsURL + clientId + urlsAPI.notesURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateNotes', response.data);
          }
        })
        .catch(handlerError);
    },

    createNote({ commit }, { clientId, body }) {
      axiosInstance.post(urlsAPI.clientsURL + clientId + urlsAPI.notesURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('addNote', response.data);
          }
        })
        .catch(handlerError);
    },

    updateNote({ commit }, { clientId, noteId, body }) {
      axiosInstance.put(urlsAPI.clientsURL + clientId + urlsAPI.notesURL + noteId, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('putNote', response.data);
          }
        })
        .catch(handlerError);
    },

    delete({ commit }, { clientId, noteId }) {
      axiosInstance.delete(urlsAPI.clientsURL + clientId + urlsAPI.notesURL + noteId)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', noteId);
          }
        })
        .catch(handlerError);
    },
  },
};
